<mbs-modal
  #modal
  [isCustomModal]="true"
  [showFooter]="true"
  [titleTextOverflow]="true">
  <ng-container modal-header>
    <mbs-text-ellipsis
      placement="top-left auto"
      tooltipClass="tooltip-lg d-block"
      [tooltip]="title">
      {{ title }}
    </mbs-text-ellipsis>
  </ng-container>
  <ng-container modal-body>
    <form
      class="mbs-form"
      [formGroup]="uninstallAgentForm">
      <fieldset class="mbs-form_content">
        <div
          class="mbs-form-group"
          formGroupName="agentList">
          <h5 class="mbs-form-group_title">
            {{
              (isPluralText ? 'shared:modals.uninstModalSelectAgentPlural' : 'shared:modals.uninstModalSelectAgent')
                | i18next: { format: 'title' }
            }}
          </h5>
          <div class="row">
            @if (showBackup) {
              <div class="col-6">
                <mbs-checkbox
                  formControlName="backup"
                  label="{{ 'shared:products.backup' | i18next }}"></mbs-checkbox>
              </div>
            }
            @if (showRmm) {
              <div class="col-6">
                <mbs-checkbox
                  formControlName="rmm"
                  label="{{ 'shared:products.rmm' | i18next }}"></mbs-checkbox>
              </div>
            }
            @if (showConnect) {
              <div class="col-6">
                <mbs-checkbox
                  formControlName="ra"
                  label="{{ 'shared:products.remote_desktop' | i18next }}"></mbs-checkbox>
              </div>
            }
            <div
              *ngIf="showDeepInst"
              class="col-6">
              <mbs-checkbox
                formControlName="deepInst"
                label="{{ 'shared:products.deepinst' | i18next }}"></mbs-checkbox>
            </div>
          </div>
        </div>
        <mbs-alert
          class="mb-0"
          [icon]="true"
          [type]="alertType.warning">
          {{ (isPluralText ? 'shared:modals.uninstModalAlertTextPlural' : 'shared:modals.uninstModalAlertText') | i18next }}
        </mbs-alert>
      </fieldset>
    </form>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="danger"
      [disabled]="!agentListForm.valid"
      [loading]="loading"
      (click)="handleResolve()">
      {{ 'shared:modals.uninstModalUninstall' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()"
      >{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</mbs-button
    >
  </ng-container>
</mbs-modal>
